import { render } from "./StorefrontExtra.vue?vue&type=template&id=33ad81d3"
import script from "./StorefrontExtra.vue?vue&type=script&lang=js"
export * from "./StorefrontExtra.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__